import { render, staticRenderFns } from "./ProjectCommercialValue.vue?vue&type=template&id=1f10520c&"
import script from "./ProjectCommercialValue.vue?vue&type=script&lang=js&"
export * from "./ProjectCommercialValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports